export enum ERoles {
	user = 'user',
	restWorkAdministrator = 'rest_work_admin',
	administrator = 'admin',
	/** Aligns with backend Role.UNIT_ADMIN (OMS unit level editors). */
	unitAdmin = 'OMS_UNIT_ADMIN',
	alertsViewer = 'alerts_viewer',
	alertsImageViewer = 'alerts_image_viewer',
	shiftCreate = 'shift_create',
	shiftDashboard = 'shift_dashboard',
	developer = 'developer',
	samsara = 'OMS_SAMSARA',
	instructor = 'OMS_INSTRUCTOR',
	/** Aligns with backend Role.RUN_SAMSARA_ICS_SYNC_JOB (view and run only the Samsara ICS Sync cron job). */
	runSamsaraIcsSyncJob = 'OMS_RUN_SAMSARA_ICS_SYNC_JOB',
}
